export const tiles = [
  [24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 24, 24, 25, 24, 24, 24, 26, 24, 29],
  [33, 1, 4, 1, 8, 1, 1, 4, 6, 2, 32, 31, 0, 1, 1, 6, 1, 1, 1, 32],
  [31, 1, 1, 2, 1, 2, 2, 1, 1, 3, 32, 31, 2, 7, 1, 2, 1, 1, 1, 32],
  [31, 1, 1, 1, 2, 1, 5, 6, 1, 6, 32, 31, 1, 1, 1, 1, 1, 1, 7, 32],
  [31, 1, 1, 1, 29, 33, 2, 5, 1, 1, 30, 39, 4, 1, 3, 3, 3, 0, 6, 30],
  [33, 1, 1, 5, 32, 31, 1, 1, 7, 1, 1, 1, 1, 3, 3, 1, 1, 1, 1, 9],
  [31, 2, 3, 5, 32, 31, 6, 1, 1, 2, 5, 2, 1, 1, 5, 3, 0, 3, 3, 29],
  [31, 1, 1, 1, 32, 31, 2, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 2, 1, 32],
  [24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 32],
  [49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 32]
];

//20 wide 10 tall map

//0 represents walkable land.
//1 is blocked land.

//Other numbers will be assigned to intractable tile
